import React, { useMemo } from 'react';
import { ProductCardList } from '@wix/premium-purchase-platform/@components';
import {
  FREE_DOMAIN_PLAN_CARD_TRANSLATION_KEY,
  useCurrentModule,
  useDomainIntent,
} from '@wix/package-picker-shared-eclipse';
import { ProductCardFeatureRow } from './ProductCardFeatureRow';
import { ProductCardFeatureRowWithDescription } from './ProductCardFeatureRowWithDescription';
import { Box } from '@wix/design-system';

export const FeatureList = ({ productId }: { productId: string }) => {
  const module = useCurrentModule();
  const { experiments } = module.internals.experiments.hooks.useExperiments();
  const isFeatureDescriptionEnabled = experiments.isEnabled(
    'specs.premium.premiumEclipseFeatureDescription',
  );
  const { data: product } =
    module.SDK.eclipseOfferingApiClient.hooks.useFetchProduct({
      productId,
    });

  const { shouldShowDomainFirst } = useDomainIntent();

  const features = useMemo(() => {
    const rawFeatures = product?.features ?? [];
    if (!shouldShowDomainFirst || rawFeatures.length === 0) {
      return rawFeatures;
    }
    const domainIndex = rawFeatures.findIndex(
      (f) =>
        f.content?.localized?.translationKey ===
        FREE_DOMAIN_PLAN_CARD_TRANSLATION_KEY,
    );
    if (domainIndex <= 0) {
      return rawFeatures;
    }
    const domain = rawFeatures[domainIndex];
    const rest = rawFeatures.filter((_, i) => i !== domainIndex);
    return [domain, ...rest];
  }, [product?.features, shouldShowDomainFirst]);

  if (!features || !Array.isArray(features) || features.length === 0) {
    return null;
  }

  return (
    <Box direction="vertical" width="100%">
      <ProductCardList.Default.Card.FeatureList
        boxSizing="border-box"
        gap="16px"
        verticalAlign="top"
        renderRow={(row) =>
          isFeatureDescriptionEnabled ? (
            <ProductCardFeatureRowWithDescription row={row} />
          ) : (
            <ProductCardFeatureRow row={row} />
          )
        }
        features={features ?? []}
      />
    </Box>
  );
};
